import Avatar from '@mui/material/Avatar';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import placeholderSrc from 'assets/avatar.jpg';
import Image from 'components/Image';

const size = 40;
const styles = {
  avatar: {
    borderRadius: '50%',
    overflow: 'hidden',
  },
};

class Headshot extends PureComponent {
  static propTypes = {
    person: PropTypes.object,
    relay: PropTypes.object.isRequired,
    style: PropTypes.object,
  };
  render() {
    const { person, style, ...props } = this.props;
    return (
      <Avatar
        {...props}
        style={{
          ...styles.avatar,
          ...style,
          width: size,
          height: size,
        }}
      >
        <Image
          alt='User headshot'
          placeholderSrc={placeholderSrc}
          showLoading={false}
          src={person && person.headshot}
        />
      </Avatar>
    );
  }
}

export default Headshot;
